import { OptimisticItem } from '../types/optimistic-item';

export const createOptimisticItem = <T extends object>(
  item: T,
): OptimisticItem<T> => {
  const optimisticId = Date.now().toString();

  const optimisticItem: OptimisticItem<T> = {
    ...item,
    optimisticId,
  };

  return optimisticItem;
};
